export class AbstractTransport {
    runtimeOpts = {};

    getRuntimeOpts() {
        return this.runtimeOpts;
    }

    applyRuntimeOpts(opts) {
        Object.assign(this.runtimeOpts, opts || {});
    }

    /**
     * Takes formatted message and logs it in the way you need
     * @param {any} message - result of format function, { lvl, parts, tsz } by default
     * @returns {(Promise|any)} - may be async and return a Promise of logging process
     */
    log() {
        throw new Error('The .log() method isn\'t implemented.');
    }
}
